<!-- 날자 선택용 공통 컴포넌트 -->
<template>
  <v-container fluid>
    <v-row>
        <v-menu
          v-model="start_date"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
          >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="curdate"
              :label="labeltext"
              prepend-icon="access_time"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker v-model="curdate" :first-day-of-week="0" :locale="$i18n.locale">
            <v-spacer></v-spacer>
            <v-btn rounded large color="primary" @click="start_date = false">Cancel</v-btn>
            <v-btn rounded large color="primary" @click="save_date">OK</v-btn>            
          </v-time-picker>
        </v-menu>                    
    </v-row>
  </v-container>
</template>

<script>
    export default {

        mounted(){
          this.curdate = this.inputtime;
        },
        
        //전달받을 프로퍼티 정의, 타입을 정의해도 되고 안해도 되고
        props:{
            inputtime: {type:String, default:"09:00"},
            labeltext: {type:String, default:""},
        },

        data: ()=> ({
            start_date:false,
            curdate : "09:00",
        }),

        methods: {

            //추가 저장
            save_date () {

                if(this.curdate.length > 0){
                    this.$emit('callback', this.curdate)
                    this.start_date = false;  //닫기
                }else{
                    this.$alert(this.$t('comtimepicker_msg2'));
                    return;
                }
                
            },      

        }

    }
</script>

<style scoped>

</style>